<template>
  <div class="outdated-paid-not-refunded">
    <h1 class="normal" id="page-title-for-sr">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.outdatedPaidNotRefunded.header')"></span>
    </h1>
    <p v-html="$t('confirmation.outdatedPaidNotRefunded.description')"></p><p v-html="$t('confirmation.outdatedPaidNotRefunded.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationOutdatedPaidNotRefunded'
}
</script>
